module.exports = __webpack_public_path__ + "static/chess-49e65ee43ac5a9675a0a6608175ca031.png";